import { render, staticRenderFns } from "./titleText.vue?vue&type=template&id=3cc9d37f&scoped=true&"
import script from "./titleText.vue?vue&type=script&lang=js&"
export * from "./titleText.vue?vue&type=script&lang=js&"
import style0 from "./titleText.vue?vue&type=style&index=0&id=3cc9d37f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc9d37f",
  null
  
)

export default component.exports